import { cryptoEncode } from '@/util/AES'
import { env } from '@/common/host.js'
export const totodiUrl = (route) => {
  return `${env.ttdUrl}${route}`;
};

/**
 * 妥妥递所有的接口appid由后台加密处理
 */
// 开放平台注册后提供的appId
// export const app_id = env.ttdAppId;

/**
 * 数据转换
 * data    需要转换的数据
 * cryptoList  需要加密的字段
 */
export const jsonToUrlParam = (data, cryptoList = []) => {
  return Object.keys(data).map(key => {
    let val = data[key];
    if (cryptoList.includes(key)) val = cryptoEncode(data[key]);
    return `${key}=${val}`
  }).join('&');
}

/**
 * 人类跳转核验
 * **********必传参数*************
 * app_id           开放平台注册后提供的appId
 * redirect_uri     完成跳转地址
 * user_name        姓名
 * id_no            证件号
 * **********不必传参数*************
 * disabled_text_adjust       1：禁用微信字体自适应0：不禁用，非必传，默认不禁用，加密，仅使用于微信内置浏览器。
 * page_title      页面title
 * id_type        证件类型，默认“身份证”。证件类型：身份证、定居国外的中国公民护照、港澳居民来往内地通行证、台湾居民来往内地通行证、外国人永久居留身份证。
 * nation         国籍，默认“中国”
 * isFailedJump   人脸识别失败后是否有单独的跳转地址，有(“1”)；没有(“0”)，默认“0”
 * failRedirectUrl  失败跳转地址，isFailedJump为”1“必传
 */
export const getFaceUrl = (options) => {
  // 加密字段
  const cryptoList = ['user_name', 'id_no', 'id_type', 'nation', 'disabled_text_adjust'];
  return totodiUrl(`/v2/face?${jsonToUrlParam(options, cryptoList)}`);
}

/**
 * 投资者批量文件签署
 * **********必传参数*************
 * app_id 开放平台注册后提供的appId
 * user_no    用户标识
 * redirect_uri   签署完成跳转地址,会带上签署参数
 * **********不必传参数*************
 * disabled_text_adjust       1：禁用微信字体自适应0：不禁用，非必传，默认不禁用，加密，仅使用于微信内置浏览器。
 * filed_ids  自定义文件集合（半角逗号分割），备注：filed_ids和order_no至少传一个
 * order_no     订单编号，备注：filed_ids和order_no至少传一个
 * agent_sign        机构投资者是否进行签字（默认不需要，只有章）1：需要，0：不需要
 * only_unsigned      展示全部文件传“0”, 只展示未签署文件传”1”，默认展示全部文件
 * remove_history     退出签署时清除浏览器历史栈，“0”: 不清除，“1”: 清除，默认不清除
 * auto_sign_pic      签名板自动生成楷体签名图片或手动书写签；”0”：手动书写签署，“1”：自定生成楷体签名
 * hide_sign_board_switch     是否隐藏签字板横竖屏切换按钮，”0”不隐藏，“1”隐藏，默认不隐藏
 * signature_type     签字类型。传参枚举：0 | 1 | 2 (手写 | 系统生成图片 | 用户上传图片)
 * signature_image      签字图片。链接需要为可解析图片格式，传了优先使用传参图片否则请求数据库保存图片
 * password_check       是否校验投资者签署密码，非必传，默认不校验，传参枚举：0 | 1(不校验 | 校验) 注：限自然人投资者
 */
export const getListUrl = (options) => {
  // 加密字段
  const cryptoList = ['filed_ids', 'order_no', 'agent_sign', 'user_no', 'signature_type', 'signature_image', 'password_check', 'disabled_text_adjust'];
  return totodiUrl(`/list?${jsonToUrlParam(options, cryptoList)}`);
}

/**
 * 自定义文件签署
 * **********必传参数*************
 * app_id             开放平台注册后提供的appId
 * file_id            文件唯一ID
 * sign_type          签约类型 投资者签署传：“1”，理财师签署传：“2”, 机构经办人：“4”，
 * redirect_uri       签署完成跳转地址,会带上签署参数
 * **********不必传参数*************
 * disabled_text_adjust       1：禁用微信字体自适应0：不禁用，非必传，默认不禁用，加密，仅使用于微信内置浏览器。
 * user_no            用户id 投资者必传，理财师可以不传
 * mobile             自然人可以不传,理财师必传的手机号
 * id_card            自然人可以不传,理财师必传的身份证号
 * name               自然人可以不传,理财师必传的姓名
 * title              签署页面title
 * style_type         定制样式才会用到
 * multiple_sign      redirect_uri如果为标准签署或自定义签署链接则传“true”，不是则不传
 * hide_sign_board_switch     是否隐藏签字板横竖屏切换按钮，”0”不隐藏，“1”隐藏，默认不隐藏
 * signature_type     签字类型。传参枚举：0 | 1 | 2 (手写 | 系统生成图片 | 用户上传图片)
 * signature_image    签字图片。链接需要为可解析图片格式，传了优先使用传参图片否则请求数据库保存图片
 */
export const getCustomUrl = (options) => {
  // 加密字段
  const cryptoList = ['file_id', 'sign_type', 'user_no', 'mobile', 'id_card', 'name', 'signature_type', 'signature_image', 'disabled_text_adjust'];
  return totodiUrl(`/custom?${jsonToUrlParam(options, cryptoList)}`);
}
